import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import i18n from '@/js/i18n.js'
import { f7 } from 'framework7-vue'

export function useTransactionStatus() {
  const t = i18n.global.t

  const statusMap = {
    COMPLETE: { actualVal: 'COMPLETE', value: 'SUCCESSFUL', status: t('common.confirmed'), color: 'green' },
    SUCCESSFUL: { value: 'SUCCESSFUL', status: t('common.confirmed'), color: 'green' },
    CONFIRMED: { value: 'CONFIRMED', status: t('common.confirmed'), color: 'green' },
    SUCCEEDED: { value: 'SUCCEEDED', status: t('common.confirmed'), color: 'green' },
    SUCCES: { value: 'SUCCES', status: t('common.confirmed'), color: 'green' },
    ACCEPTED: { value: 'ACCEPTED', status: t('common.accepted'), color: 'green' },
    INITIATED: { value: 'INITIATED', status: t('common.initiated'), color: 'orange' },
    REFUNDED: { value: 'REFUNDED', status: t('common.refunded'), color: 'teal' },
    INSUFFICIENT_BALANCE: { value: 'INSUFFICIENT_BALANCE', status: t('common.insufficient_balance'), color: 'red' },
    AUTHORIZED: { value: 'AUTHENTICATED', status: t('common.authorized'), color: 'darkorange' },
    CANCELLED: { value: 'CANCELLED', status: t('common.cancelled'), color: 'red' },
    TRANSACTION_CANCEL: { value: 'TRANSACTION_CANCEL', status: t('common.cancelled'), color: 'red' },
    TO_VALIDATE: { value: 'TO_VALIDATE', status: t('common.to_validate'), color: 'orange' },
    PENDING: { value: 'PENDING', status: t('common.to_validate'), color: 'orange' },
    PENDING_ON_CONFIRMATION: { value: 'PENDING_ON_CONFIRMATION', status: t('common.to_validate'), color: 'orange' },
    INPROGRESS: { value: 'INPROGRESS', status: t('common.to_validate'), color: 'orange' },
    OPEN: { value: 'OPEN', status: t('common.to_validate'), color: 'orange' },
    requires_payment_method: { value: 'requires_payment_method', status: t('common.to_validate'), color: 'orange' },
    PROCESSING: { value: 'PROCESSING', status: t('common.to_validate'), color: 'orange' },
    REJECTED: { value: 'REJECTED', status: t('common.rejected'), color: 'red' },
    FAILED: { value: 'FAILED', status: t('common.failed'), color: 'red' },
    REQUIRES_PAYMENT_METHOD: { value: 'REQUIRES_PAYMENT_METHOD', status: t('common.to_validate'), color: 'orange' },
    TIMED_OUT_3DS: { value: 'TIMED_OUT_3DS', status: t('common.timed_out_3DS', { threeDS: '3DS' }), color: 'red' },
    TIMED_OUT: { value: 'TIMED_OUT', status: t('common.timed_out'), color: 'red' },
    EXPIRED: { value: 'EXPIRED', status: t('common.timed_out'), color: 'red' },
    // Unified PaymentTransactionStatus enum values not covered above
    SUCCESS: { value: 'SUCCESS', status: t('common.confirmed'), color: 'green' },
    APPROVED: { value: 'APPROVED', status: t('common.approved'), color: 'green' },
    PARTIALLY_REFUNDED: { value: 'PARTIALLY_REFUNDED', status: t('common.partially_refunded'), color: 'teal' },
    PENDING_APPROVAL: { value: 'PENDING_APPROVAL', status: t('common.pending_approval'), color: 'orange' },
  }

  function transactionStatus(status) {
    const normalizedStatus = status?.toUpperCase().replace(/\s+/g, '_')
    return statusMap[normalizedStatus]
  }

  function transactionsStatusList(transactions) {
    if (!transactions) return []
    const seen = new Set()
    return transactions
      .map((tx) => transactionStatus(tx.status))
      .filter((status) => {
        if (!status || seen.has(status.value)) return false
        seen.add(status.value)
        return true
      })
  }

  return {
    statusMap,
    transactionStatus,
    transactionsStatusList,
  }
}
